// Why: HologramSceneContext(useState) 경로는 모달 rAF가 매 프레임마다 setState를 호출해
// MainLayout 전체 트리가 60fps로 리렌더링되는 비용이 컸음. 셰이더는 자체 rAF 안에서 매 프레임
// 이 store를 폴링하면 되니까 React state 갱신이 필요 없음. 두 값을 mutable 모듈 변수로 보관.
export const hologramSceneStore = {
  modalActive: 0,
  modalProgress: 0,
  // HologramModal이 viewport에 맞춰 slate를 cap한 비율 (1.0 = 원본).
  // 셰이더가 그리는 slate 데코(코너 브래킷·glow)도 같은 비율로 축소되어 HTML과 정합.
  modalScale: 1,
  // 광원장 와이어프레임 → 렌더 (0 = 전부 와이어, 1 = 다 렌더). 밑단 가운데를 쥐어 베일을 위로 걷어 올린다.
  reveal: 1,
  // 베일에 실어 함께 넘기는 접속 승인 모달 (화면 크기 캔버스). 바꿀 때는 setVeilPanel 을 쓴다.
  veilPanel: null as TexImageSource | null,
  // 셰이더가 텍스처를 다시 올려야 하는지 알려 준다 — 캔버스 비교 대신 번호로 본다
  veilPanelVersion: 0,
};

export function setVeilPanel(panel: TexImageSource | null) {
  hologramSceneStore.veilPanel = panel;
  hologramSceneStore.veilPanelVersion += 1;
}
